<div class="card">
  <div class="card-header-filter">
    <div class="heading-flex">
      <p>{{ variables?.notifications || 'Notificaciones' }}</p>
      <div class="filters">
        <p class="ps" style="margin: auto; display: flex; justify-content: center;">
          <span style="margin: auto; font-size:12px;">{{variables.filters}} &nbsp; </span>
          @if (!showFiltersValue) {
          <mat-icon class="filter-icon" (click)="showFilters()">keyboard_arrow_down</mat-icon>
          }
          @else {
          <mat-icon class="filter-icon" (click)="showFilters()">keyboard_arrow_up</mat-icon>
          }
        </p>
      </div>
    </div>

    @if (showFiltersValue) {
    <mat-divider style="margin-bottom:20px"></mat-divider>

    <div class="filters-row">
      <mat-form-field appearance="outline" class="filter-field type-filter-field" floatLabel="always">
        <mat-label>{{ variables?.notificationType || 'Tipo' }}</mat-label>
        <mat-select [(ngModel)]="filterType" (selectionChange)="applyFilters()">
          <mat-option value="">{{ variables?.allNotifications || 'Todas' }}</mat-option>
          <mat-option *ngFor="let type of typeOptions" [value]="type.value">{{ type.icon }}{{ type.label }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="filter-field" >
        <mat-label>{{ variables?.priority || 'Prioridad' }}</mat-label>
        <mat-select [(ngModel)]="filterPriority" (selectionChange)="applyFilters()">
          <mat-option value="">{{ variables?.allNotifications || 'Todas' }}</mat-option>
          <mat-option value="1">{{ variables?.priorityVeryHigh || 'Muy alta' }}</mat-option>
          <mat-option value="2">{{ variables?.priorityHigh || 'Alta' }}</mat-option>
          <mat-option value="3">{{ variables?.priorityMedium || 'Media' }}</mat-option>
          <mat-option value="4">{{ variables?.priorityLow || 'Baja' }}</mat-option>
          <mat-option value="5">{{ variables?.priorityVeryLow || 'Muy baja' }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="filter-field date-filter-field" floatLabel="always">
        <mat-label>{{ variables?.fromDate || 'Fecha desde' }}</mat-label>
        <input matInput [matDatepicker]="fromPicker" placeholder="{{variables?.dateplaceholder || 'mm/dd/aaaa'}}" [(ngModel)]="filterDateFrom"
          (dateChange)="applyFilters()" readonly>
        <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="filter-field date-filter-field" floatLabel="always">
        <mat-label>{{ variables?.toDate || 'Fecha hasta' }}</mat-label>
        <input matInput [matDatepicker]="toPicker" placeholder="{{variables?.dateplaceholder || 'mm/dd/aaaa'}}" [(ngModel)]="filterDateTo"
          (dateChange)="applyFilters()" readonly>
        <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>{{ variables?.notificationRead || 'Leido' }}</mat-label>
        <mat-select [(ngModel)]="filterRead" (selectionChange)="applyFilters()">
          <mat-option value="unread">{{ variables?.filterUnread || 'Unread' }}</mat-option>
          <mat-option value="read">{{ variables?.filterRead || 'Read' }}</mat-option>
          <mat-option value="all">{{ variables?.filterAll || 'All' }}</mat-option>
        </mat-select>
      </mat-form-field>

      <div class="filters-actions">
        <app-button typeBtn="primary" (click)="clearFilters()" [message]="variables?.clear || 'Limpiar'"></app-button>
      </div>
    </div>
    }

    @if (dateValidationError) {
    <div class="date-error">
      {{ dateValidationError }}
    </div>
    }

    @if (isLoading && !errorDetected) {
    <app-loader class="centerLoader"></app-loader>
    }

    @if (errorDetected) {
    <app-error-message [errorMsg]="errorText"></app-error-message>
    }

    <mat-divider> </mat-divider>

    @if (!isLoading && !errorDetected) {
    <div class="table-container">
      <table mat-table [dataSource]="notifications" class="notifications-table">

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>{{ variables?.notificationType || 'Tipo' }}</th>
          <td mat-cell *matCellDef="let notification">{{ notification.icon }}{{ notification.label }}</td>
        </ng-container>

        <ng-container matColumnDef="subject">
          <th mat-header-cell *matHeaderCellDef>{{ variables?.notificationSubject || 'Assunto' }}</th>
          <td mat-cell *matCellDef="let notification">{{ notification.subject }}</td>
        </ng-container>

        <ng-container matColumnDef="priority">
          <th mat-header-cell *matHeaderCellDef>{{ variables?.priority || 'Prioridad' }}</th>
          <td mat-cell *matCellDef="let notification">
            <span class="priority-chip" [ngClass]="getPriorityClass(notification.priority)">
              {{ getPriorityLabel(notification.priority) }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>{{ variables?.notificationDate || 'Fecha' }}</th>
          <td mat-cell *matCellDef="let notification">{{ notification.date}}</td>
        </ng-container>

        <ng-container matColumnDef="readDate">
          <th mat-header-cell *matHeaderCellDef>{{ variables?.notificationReadDate || 'Fecha de lectura' }}</th>
          <td mat-cell *matCellDef="let notification">{{ formatReadDate(notification.readDate) }}</td>
        </ng-container>

        <ng-container matColumnDef="read">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;">{{ variables?.notificationRead || 'Leido' }}</th>
          <td mat-cell *matCellDef="let notification" style="text-align: center;">
            <mat-checkbox class="notification-read-checkbox" [checked]="notification.readDate" [disabled]="true"></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;">{{ variables?.action || 'Acción' }}</th>
          <td mat-cell *matCellDef="let notification" style="text-align: center;">
              <button type="button" class="action_buttons-item action_buttons-item-primary"
                (click)="openDetail(notification)" [matTooltip]="variables?.view || 'Ver'" matTooltipPosition="above">
                <mat-icon>remove_red_eye</mat-icon>
              </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <div class="paginator-row">
        <mat-paginator [length]="totalElements" [pageIndex]="pageIndex" [pageSize]="pageSize"
          [pageSizeOptions]="[5, 10, 20]" (page)="onPageChange($event)">
        </mat-paginator>
      </div>
    </div>
    }
  </div>
</div>

<div class="configure-actions">
  <app-button typeBtn="primary" (click)="goToConfig()"
    [message]="variables?.configureNotifications || 'Configurar notificaciones'"></app-button>
</div>